import { FeatureFlag } from '~/types/company';
import { MetaDataCursorPage } from '~/types/jsonapi';

export interface Subscription {
  id: string;
  createdAt: string;
  externalId: string;
  updatedAt: string;
  status: SubscriptionStatus;
  company?: { id: string };
}

export enum SubscriptionStatus {
  PreTrial = 'PRE_TRIAL',
  Trial = 'TRIAL',
  TrialWillEnd = 'TRIAL_WILL_END',
  TrialWithPaymentMethod = 'TRIAL_WITH_PAYMENT_METHOD',
  Active = 'ACTIVE',
  Incomplete = 'INCOMPLETE',
  PastDue = 'PAST_DUE',
  Canceled = 'CANCELED',
  Unpaid = 'UNPAID',
}

export interface SubscriptionsMeta {
  page: MetaDataCursorPage;
}

export interface SubscriptionsMeta {
  page: MetaDataCursorPage;
}

export const SubscriptionQueryKeys = {
  CustomerPortal: (companyId: string, subscriptionId: string) => [
    'Subscription',
    companyId,
    'CustomerPortal',
    subscriptionId,
  ],
  Subscriptions: (companyId: string) => ['Subscriptions', companyId],
};

export interface SubscriptionCustomerPortal {
  url: string;
}

export interface NewSecondCompanySubscriptionInfoResponse {
  price: number;
  interval: 'month' | 'year';
  interval_count: number;
  discounted_price: number;
  features: FeatureFlag[];
}
